var map = {
	"./1.png": "WLh9",
	"./1@2x.png": "oOXY",
	"./2.png": "hF25",
	"./2@2x.png": "4LqY",
	"./3.png": "HYTC",
	"./3@2x.png": "+9cv",
	"./4.png": "nGA6",
	"./4@2x.png": "Az5a"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "76QG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/barometer ^\.\/.*\.png$
// module id = 76QG
// module chunks = 1